<template>
    <v-dialog v-model="shows" persistent max-width="550" content-class="rounded-lg">
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on, isValid }" />
        </template>

        <v-sheet class="full-height">
            <v-layout column fill-height>
                <bottom-sheet-header style="position: relative">
                    이용약관
                    <v-btn small text fab tile absolute right color="white" @click="shows = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </bottom-sheet-header>

                <v-sheet class="scroll-primary py-40 px-60" style="flex: 1 1 auto; overflow-y: auto">
                    <v-layout class="mb-12"> <v-spacer /> <v-checkbox v-model="isValid" label="전체 동의" readonly @click="toggleSelectedAll" hide-details /> </v-layout>
                    <v-divider />
                    <v-sheet v-for="term in termsList" :key="term._id" class="mt-12">
                        <v-row class="row--small">
                            <v-col>
                                <h4 class="page-text--lg">{{ term.subject }}</h4>
                            </v-col>
                            <v-col cols="auto">
                                <v-checkbox v-model="selected" :value="term._id" label="약관동의" hide-details />
                            </v-col>
                        </v-row>
                        <v-card rounded outlined class="scroll-primary mt-8" style="height: 20vh; overflow-y: auto">
                            <div class="pa-12">
                                <p class="page-text--sm grey--text" v-html="term.content" />
                            </div>
                        </v-card>
                    </v-sheet>
                    <div class="v-btn-group">
                        <v-btn outlined color="grey-d" @click="cancel" class="min-w-140px min-w-lg-160px"><span class="grey-6--text">취소하기</span></v-btn>
                        <v-btn color="primary" @click="agree" class="min-w-140px min-w-lg-160px"><span>동의하기</span></v-btn>
                    </div>
                </v-sheet>
            </v-layout>
        </v-sheet>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables";
import VPreviewInput from "@/components/plugins/vuetify/v-preview-input.vue";
import BottomSheetHeader from "@/components/dumb/bottom-sheet-header.vue";

export default {
    components: {
        VPreviewInput,
        BottomSheetHeader,
    },
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        shows: false,
        isLoaded: false,
        selected: [],
        termsList: [],

        attrs_input,
    }),
    computed: {
        isValid() {
            return !this.termsList.some(({ _id }) => !this.selected.includes(_id));
        },
    },
    methods: {
        async init() {
            this.isLoaded = false;

            var { termsList } = await api.v1.terms.gets({});
            this.termsList = termsList;

            this.isLoaded = true;
        },
        sync() {
            this.selected = [...this.value];
        },

        toggleSelectedAll() {
            if (this.isValid) this.selected = [];
            else this.selected = this.termsList.map(({ _id }) => _id);
        },
        cancel() {
            this.selected = this.value;
            this.shows = false;
        },
        agree() {
            this.$emit("input", this.selected);
            this.$emit("isValid", this.isValid);
            this.shows = false;
        },
    },
    watch: {
        value() {
            this.sync();
        },

        shows() {
            if (this.shows) this.init();
        },

        isLoaded(isLoaded) {
            if (isLoaded) this.$emit("isLoaded", this.termsList);
        },

        isValid() {
            this.$emit("isValid", this.isValid);
        },
    },
    mounted() {
        this.init();
        this.sync();
        this.$emit("isValid", this.isValid);
    },
};
</script>

<style></style>
